import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { IProxyActiveCheckIn } from 'src/app/models/user';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { mapsPayload } from 'src/app/app-store/map/map.selector';
import { IProductLine, IWorkingStatus } from 'src/app/models/map';
import workingStatus from '../../../../assets/working-status.json';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-group-details',
  templateUrl: './group-details.component.html',
  styleUrls: ['./group-details.component.css']
})
export class GroupDetailsComponent implements OnInit, OnDestroy {

  statusImage: string;
  productLineName: string;
  statusTitle: string;
  productLines: IProductLine[];
  workingStatus: IWorkingStatus[] = workingStatus;
  workingStatuses: IWorkingStatus[];
  mapsPayloadSubscription:Subscription;

  constructor(private store: Store, public dialogRef: MatDialogRef<GroupDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IProxyActiveCheckIn) {
  }

  ngOnInit(): void {
    this.mapsPayloadSubscription = this.store.pipe(select(mapsPayload)).subscribe(response => {
      if (response !== undefined) {
        this.workingStatuses = response.workingStatuses.filter(x => x.id === 1 || x.id === 3 || x.id === 5 || x.id === 6);
      }
    });

    this.store.pipe(select(mapsPayload)).subscribe(response => {
      if (response !== undefined) {
        this.productLines = response.productLines;

      }
    });
    this.statusTitle = this.workingStatuses.filter(x => x.name === this.data.workingStatus)[0].localizedText;
    this.statusImage = this.workingStatus.filter(x => x.id === this.data.workingStatusId)[0].image;

    this.productLineName = this.productLines.filter(x => x.code === this.data.productLineCode)[0].name;
  }

  onCancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    if (this.mapsPayloadSubscription) {
      this.mapsPayloadSubscription.unsubscribe();
    }
  }
}
